import { List, ListItem } from '@montugroup/design-system';
import type { Prescription as PrescriptionItemType, ScriptMetadata } from './common';
import { getUniqueKey } from './common';
import { StyledPrescription } from './Prescription.styles';
import PrescriptionAccordion from './PrescriptionAccordion';
import { PrescriptionHeader } from './PrescriptionHeader';

export interface IPrescription {
  prescriptionCode: string;
  prescriptionMetadata: ScriptMetadata;
  prescription: PrescriptionItemType[];
}

export function Prescription({ prescriptionCode, prescriptionMetadata, prescription }: IPrescription) {
  return (
    <StyledPrescription>
      <PrescriptionHeader prescriptionCode={prescriptionCode} prescriptionMetadata={prescriptionMetadata} />

      <List disablePadding>
        {prescription.map((prescriptionItem, index) => (
          <ListItem
            key={getUniqueKey(prescriptionItem)}
            disableGutters
            disablePadding
            sx={{ display: 'block' }}
            divider={index !== prescription.length - 1}
          >
            <PrescriptionAccordion prescription={prescriptionItem} prescriptionMetaData={prescriptionMetadata} />
          </ListItem>
        ))}
      </List>
    </StyledPrescription>
  );
}
export default Prescription;
